import React, { useEffect, useState } from 'react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import banner from '../../assets/home/hammockbanner.png';
import { Box, Button, Typography } from '@mui/material';
import { useMediaQueries } from '../../usecontext/UseProvider';
import { getHomeSlogan } from '../../services/HomeSlogan';
import { useNavigate } from 'react-router-dom';

const PerfectHammock = () => {
  const { isSmallScreen, isMediumScreen, isLargeScreen } = useMediaQueries();
  const [homeSloganData, setHomeSloganData] = useState([])
  const navigate = useNavigate();

  const getHomeSloganData = async () => {
    try {
      const response = await getHomeSlogan();
      setHomeSloganData(response.homeSloganData);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getHomeSloganData();
  }, []);

  return (
    <Box
      sx={{
        bgcolor: '#f5f5f5',
        height: '100%',
        position: 'relative'
      }}
    >
      <Box sx={{ position: 'relative', zIndex: 2, height: { sm: '100%', xs: '200px' }, }} >
        <Box sx={{
          position: 'absolute',
          top: 0,
          height: '100%',
          width: '100%',
          backgroundColor: ' #00000066',
          backdropFilter: 'blur(4px)',
        }}></Box>
        <img src={banner} alt='banner' className='w-100 h-100' />
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 2, // Ensure it stays above other content
            width: { sm: '60%', xs: '100%' },
            px: 3
          }}
        >
          <Typography
            data-aos="fade-up"
            data-offset="200"
            variant={isMediumScreen ? 'h6' : isLargeScreen ? 'h5' : 'h4'}
            sx={{
              color: '#fff',
              textAlign: 'center',
              fontWeight: 700,
              mt: isSmallScreen ? 1 : 2,
              mb: isSmallScreen ? 1 : 3
            }}
          >
            {homeSloganData?.slogan}
          </Typography>
          <Typography
            data-aos="fade-up"
            sx={{
              color: '#fff',
              textAlign: 'center',
              fontSize: isLargeScreen ? '16px' : '20px',
              lineHeight: isLargeScreen ? 'unset' : '36px',
              display: isMediumScreen ? 'none' : 'block',
            }}
          >
            {homeSloganData?.description}
          </Typography>
          <Box sx={{ textAlign: 'center' }}>
            <Button
              data-aos="fade-up"
              data-aos-delay="400"
              variant="varient"
              size={isSmallScreen ? 'small' : 'medium'}
              sx={{
                fontWeight: 400,
                borderColor: '#fff',
                backgroundColor: '#01A0E2',
                color: '#fff',
                borderRadius: '0',
                mt: { md: 4, xs: 0 },
                width: '190px',
                height: '44px',
                fontSize: { md: '20px' }
              }}
              onClick={() => navigate("/contactus")}>
              Discover more
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default PerfectHammock;